import React from 'react';

/**
 * Tasto «Cerca» e stato iniziale delle pagine di analisi su GO.
 *
 * Le pagine partono vuote: leggere da Gestionale Open e' lento e il loader
 * blocca la pagina, quindi la prima lettura la decide l'utente. Finche' non ha
 * cercato, il tasto e' evidenziato come quando i filtri sono da applicare.
 */

interface PropsBottone {
  cercato: boolean;
  modificati: boolean;
  disabled: boolean;
  onClick: () => void;
}

export function BottoneCercaGo({ cercato, modificati, disabled, onClick }: PropsBottone) {
  const titolo = !cercato
    ? 'Legge i dati da GO con i filtri scelti'
    : modificati ? 'Filtri modificati: premi Cerca per applicarli' : 'Rilegge i dati da GO';
  return (
    <button
      className={`bop-btn bop-btn-primary${!cercato || modificati ? ' bop-filtro-go__cerca--da-applicare' : ''}`}
      disabled={disabled}
      onClick={onClick}
      title={titolo}
    >
      Cerca
    </button>
  );
}

export function InvitoCercaGo() {
  return (
    <div className="bop-empty-state">
      <div className="bop-empty-state__title">Nessuna ricerca eseguita</div>
      <div className="bop-empty-state__text">
        Scegli i filtri e premi «Cerca» per leggere i dati da Gestionale Open.
      </div>
    </div>
  );
}
